import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row } from 'reactstrap'
import api from '../../utils/axiosApi'
import logo from '../../img/logoW.avif'
import './styles.css'

function NewinfoPlacesRecomendations({
    placeCoor={lat:0,lon:0},
    onPlacesSelect=()=>{}
}) {
    const {t,i18n}= useTranslation()
    const [translatePos, setTranslatePos] = useState(0)
    const [loading, setLoading] = useState(true)
    const [placesRecomendation, setPlacesRecomendation] = useState([])
    useEffect(() => {
        const requestNearby = async () =>{
            try {
                const response = await api.get(`/adminsplaces/getBylatLng?latlng=${placeCoor.lat},${placeCoor.lon}`)
                setPlacesRecomendation(response.data.items)
                setTranslatePos(0)
            } catch (error) {
                //console.log(error)
            }
            setLoading(false)
        }
      requestNearby()
      return () => {
        
      }
    }, [placeCoor])
  return (
    <div className={`infoPlacesRecomendationsCont mb-2 position-relative ${placesRecomendation.length===0&&'d-none'}`}>
        <h2>{t('ActivitySuggestionsList')}
            <div className='emojiCont d-inline-block ml-1'>
                <img alt="🤘" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f918.png"/>
            </div>
        </h2>
        <div className='infoPlacesRecomendationsScroller'>
            <Row className='flex-nowrap h-100' style={{transform:`translateX(-${translatePos*50}%)`}}>
                {placesRecomendation.map((it,ind)=>{
                    return <Col key={`itemsRecomendation_${ind}`} className=' pl-1 pr-2' xs='6'>
                    <div className='itemRecomendationCont' onClick={()=>{onPlacesSelect(it)}}>
                        <div className='itemRecomendationimg' style={{backgroundImage: `url(${it.urlImg})`}}>

                        </div>
                        <p>{i18n.language==='es'? it.name: it.nameEn}</p>
                    </div>
                    </Col>
                })}
            </Row>
        </div>
            {placesRecomendation.length !== 0 && <div className='infoPlacesRecomendationsButtonCont'>
                <button type='button' onClick={()=>{
                    if(translatePos>=placesRecomendation.length-2) {

                        setTranslatePos(0)
                    }else {

                    setTranslatePos(translatePos+1)
                    }
                }}>
                    <svg width="15" height="18" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.8003 9.49971L8.96696 0.666382V6.84971H0.133631V12.1497H8.96696V18.333L17.8003 9.49971Z" fill="#BCB9B3"/>
                    </svg>
                </button>
            </div>}
            {loading && <div className='loadRecomendations'>
                <div className='loader-Cont'>
                        <div className='loader loader1'></div>
                        <div className='loader loader2'></div>
                        <div className='loader-Logo'>

                        <img className='d-block' alt='logo' src={logo}></img>
                        </div>
                    </div>
            </div>}
    </div>
  )
}
export default NewinfoPlacesRecomendations